"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InMemoryStorage = /** @class */ (function () {
    function InMemoryStorage() {
        this.inMemoryStorage = {};
    }
    InMemoryStorage.prototype.clear = function () {
        this.inMemoryStorage = {};
    };
    InMemoryStorage.prototype.getItem = function (name) {
        if (Object.keys(this.inMemoryStorage).indexOf(name) !== -1) {
            return this.inMemoryStorage[name];
        }
        return null;
    };
    InMemoryStorage.prototype.key = function (index) {
        return Object.keys(this.inMemoryStorage)[index] || null;
    };
    InMemoryStorage.prototype.removeItem = function (name) {
        delete this.inMemoryStorage[name];
    };
    InMemoryStorage.prototype.setItem = function (name, value) {
        this.inMemoryStorage[name] = String(value);
    };
    return InMemoryStorage;
}());
exports.default = InMemoryStorage;
